// ==========================================================================
// Recipe Variants & Core Dish Helper
// Groups regional variants (Tamil Nadu, Kerala, Karnataka, Andhra, Telangana)
// under their respective base dishes (Idli, Dosa, Upma, Pongal, etc.)
// ==========================================================================

export const STATE_ICONS = {
  'Tamil Nadu': '🌴',
  'Kerala': '🥥',
  'Karnataka': '🌿',
  'Andhra Pradesh': '🌶️',
  'Telangana': '🌾'
};

export const STATE_LABELS = {
  'Tamil Nadu': {
    en: 'Tamil Nadu',
    ta: 'தமிழ்நாடு',
    hi: 'तमिलनाडु',
    te: 'తమిళనాడు',
    kn: 'ತಮಿಳುನಾಡು',
    ml: 'തമിഴ്‌നാട്',
    ar: 'تاميل نادو'
  },
  'Kerala': {
    en: 'Kerala',
    ta: 'கேரளா',
    hi: 'केरल',
    te: 'కేరళ',
    kn: 'ಕೇರಳ',
    ml: 'കേരളം',
    ar: 'كيرلا'
  },
  'Karnataka': {
    en: 'Karnataka',
    ta: 'கர்நாடகா',
    hi: 'कर्नाटक',
    te: 'కర్ణాటక',
    kn: 'ಕರ್ನಾಟಕ',
    ml: 'കർണാടക',
    ar: 'كارناتاكا'
  },
  'Andhra Pradesh': {
    en: 'Andhra Pradesh',
    ta: 'ஆந்திரா',
    hi: 'आंध्र प्रदेश',
    te: 'ఆంధ్రప్రదేశ్',
    kn: 'ಆಂಧ್ರಪ್ರದೇಶ',
    ml: 'ആന്ധ്രാപ്രദേശ്',
    ar: 'أندرا براديش'
  },
  'Telangana': {
    en: 'Telangana',
    ta: 'தெலுங்கானா',
    hi: 'तेलंगाना',
    te: 'తెలంగాణ',
    kn: 'ತೆಲಂಗಾಣ',
    ml: 'തെലങ്കാന',
    ar: 'تيلانجانا'
  }
};

export const CORE_DISH_NAMES = {
  'Idli': {
    en: 'Idli',
    ta: 'இட்லி',
    hi: 'इडली',
    te: 'ఇడ్లీ',
    kn: 'ಇಡ್ಲಿ',
    ml: 'ഇഡ്ഡലി',
    ar: 'إدلي'
  },
  'Dosa': {
    en: 'Dosa',
    ta: 'தோசை',
    hi: 'डोसा',
    te: 'దోశ',
    kn: 'ದೋಸೆ',
    ml: 'ദോശ',
    ar: 'دوسا'
  },
  'Upma': {
    en: 'Upma',
    ta: 'உப்மா',
    hi: 'उपमा',
    te: 'ఉప్మా',
    kn: 'ಉಪ್ಮಾ',
    ml: 'ഉപ്പുമാവ്',
    ar: 'أوبما'
  },
  'Pongal': {
    en: 'Pongal',
    ta: 'பொங்கல்',
    hi: 'पोंगल',
    te: 'పొంగల్',
    kn: 'ಪೊಂಗಲ್',
    ml: 'പൊങ്കൽ',
    ar: 'بونغال'
  },
  'Adai': {
    en: 'Adai',
    ta: 'அடை',
    hi: 'अडई',
    te: 'అడై',
    kn: 'ಅಡೈ',
    ml: 'അട',
    ar: 'أداي'
  },
  'Egg Dosa': {
    en: 'Egg Dosa',
    ta: 'முட்டை தோசை',
    hi: 'एग डोसा',
    te: 'ఎగ్ దోశ',
    kn: 'ಎಗ್ ದೋಸೆ',
    ml: 'മുട്ട ദോശ',
    ar: 'دوسا البيض'
  },
  'Vegetable Poha': {
    en: 'Vegetable Poha',
    ta: 'வெஜிடபிள் அவல்',
    hi: 'वेज पोहा',
    te: 'వెజిటబుల్ పోహా',
    kn: 'ವೆಜಿಟೇಬಲ್ ಅವಲಕ್ಕಿ',
    ml: 'വെജിറ്റബിൾ അവൽ',
    ar: 'بوها بالخضار'
  },
  'Chapati with Vegetable Curry': {
    en: 'Chapati with Vegetable Curry',
    ta: 'சப்பாத்தி வெஜிடபிள் குருமா',
    hi: 'चपाती और वेज करी',
    te: 'చపాతీ వెజిటబుల్ కర్రీ',
    kn: 'ಚಪಾತಿ ಮತ್ತು ತರಕಾರಿ ಪಲ್ಯ',
    ml: 'ചപ്പാത്തിയും വെജിറ്റബിൾ കറിയും',
    ar: 'شاباتي مع كاري الخضار'
  },
  'Lemon Rice': {
    en: 'Lemon Rice',
    ta: 'எலுமிச்சை சாதம்',
    hi: 'लेमन राइस',
    te: 'లెమన్ రైస్ (చిత్రాన్నం)',
    kn: 'ಚಿತ್ರಾನ್ನ',
    ml: 'ലെമൺ റൈസ്',
    ar: 'أرز بالليمون'
  },
  'Tomato Rice': {
    en: 'Tomato Rice',
    ta: 'தக்காளி சாதம்',
    hi: 'टोमैटो राइस',
    te: 'టొమాటో రైస్',
    kn: 'ಟೊಮೆಟೊ ಬಾತ್',
    ml: 'തക്കാളി ചോറ്',
    ar: 'أرز بالطماطم'
  },
  'Curd Rice': {
    en: 'Curd Rice',
    ta: 'தயிர் சாதம்',
    hi: 'कर्ड राइस (दही चावल)',
    te: 'పెరుగన్నం (దద్దోజనం)',
    kn: 'ಮೊಸರನ್ನ',
    ml: 'തൈര് സാദം',
    ar: 'أرز بالزبادي'
  },
  'Sambar Rice': {
    en: 'Sambar Rice',
    ta: 'சாம்பார் சாதம்',
    hi: 'सांभर राइस',
    te: 'సాంబార్ రైస్',
    kn: 'ಬಿಸಿಬೇಳೆ ಬಾತ್',
    ml: 'സാമ്പാർ സാദം',
    ar: 'أرز السامبار'
  },
  'Tamarind Rice': {
    en: 'Tamarind Rice',
    ta: 'புளியோதரை',
    hi: 'इमली चावल',
    te: 'పులిహోర',
    kn: 'ಪುಳಿಯೋಗರೆ',
    ml: 'പുളി സാദം',
    ar: 'أرز التمر الهندي'
  },
  'Vegetable Rice': {
    en: 'Vegetable Rice',
    ta: 'காய்கறி சாதம்',
    hi: 'वेजिटेबल राइस',
    te: 'వెజిటబుల్ రైస్',
    kn: 'ತರಕಾರಿ ಅನ್ನ',
    ml: 'വെജിറ്റബിൾ റൈസ്',
    ar: 'أرز بالخضار'
  },
  'Egg Rice': {
    en: 'Egg Rice',
    ta: 'முட்டை சாதம்',
    hi: 'एग राइस',
    te: 'ఎగ్ రైస్',
    kn: 'ಮೊಟ್ಟೆ ಅನ್ನ',
    ml: 'മുട്ട ചോറ്',
    ar: 'أرز بالبيض'
  },
  'Chicken Rice': {
    en: 'Chicken Rice',
    ta: 'சிக்கன் சாதம்',
    hi: 'चिकन राइस',
    te: 'చికెన్ రైస్',
    kn: 'ಚಿಕನ್ ಅನ್ನ',
    ml: 'ചിക്കൻ റൈസ്',
    ar: 'أرز بالدجاج'
  },
  'Dal Rice': {
    en: 'Dal Rice',
    ta: 'பருப்பு சாதம்',
    hi: 'दाल चावल',
    te: 'పప్పు అన్నం',
    kn: 'ಬೇಳೆ ಅನ್ನ',
    ml: 'പരിപ്പ് സാദം',
    ar: 'أرز بالعدس'
  },
  'Rasam Rice': {
    en: 'Rasam Rice',
    ta: 'ரசம் சாதம்',
    hi: 'रसम राइस',
    te: 'చారు అన్నం',
    kn: 'ಸಾರು ಅನ್ನ',
    ml: 'രസം സാദം',
    ar: 'أرز الراسام'
  },
  'Potato Fry': {
    en: 'Potato Fry',
    ta: 'உருளைக்கிழங்கு வறுவல்',
    hi: 'आलू फ्राई',
    te: 'ఆలూ ఫ్రై',
    kn: 'ಆಲೂಗಡ್ಡೆ ಫ್ರೈ',
    ml: 'ഉരുളക്കിഴങ്ങ് ഫ്രൈ',
    ar: 'بطاطس مقلية'
  },
  'Mixed Vegetable Fry': {
    en: 'Mixed Vegetable Fry',
    ta: 'காய்கறி வறுவல் / பொரியல்',
    hi: 'मिक्स वेज फ्राई',
    te: 'మిక్స్డ్ వెజిటబుల్ ఫ్రై',
    kn: 'ತರಕಾರಿ ಪಲ್ಯ',
    ml: 'വെജിറ്റബിൾ ഉപ്പേരി',
    ar: 'خضار مقلية'
  },
  'Egg Curry': {
    en: 'Egg Curry',
    ta: 'முட்டை குழம்பு',
    hi: 'अंडा करी',
    te: 'గుడ్డు పులుసు',
    kn: 'ಮೊಟ್ಟೆ ಸಾರು',
    ml: 'മുട്ട കറി',
    ar: 'كاري البيض'
  },
  'Chicken Curry': {
    en: 'Chicken Curry',
    ta: 'சிக்கன் குழம்பு',
    hi: 'चिकन करी',
    te: 'కోడికూర (చికెన్ కర్రీ)',
    kn: 'ಕೋಳಿ ಸಾರು',
    ml: 'നാടൻ ചിക്കൻ കറി',
    ar: 'كاري الدجاج'
  },
  'Chicken Fry': {
    en: 'Chicken Fry',
    ta: 'சிக்கன் வறுவல்',
    hi: 'चिकन फ्राई',
    te: 'చికెన్ వేపుడు',
    kn: 'ಚಿಕನ್ ಸುಕ್ಕಾ',
    ml: 'ചിക്കൻ ഫ്രൈ',
    ar: 'دجاج محمر'
  },
  'Vegetable Kurma': {
    en: 'Vegetable Kurma',
    ta: 'வெஜிடபிள் குருமா',
    hi: 'वेज कोरमा',
    te: 'వెజిటబుల్ కుర్మా',
    kn: 'ವೆಜಿಟೇಬಲ್ ಕೂರ್ಮ',
    ml: 'വെജിറ്റബിൾ കുറുമ',
    ar: 'قورمة الخضار'
  },
  'Dal with Vegetables': {
    en: 'Dal with Vegetables',
    ta: 'காய்கறி பருப்பு கூட்டு',
    hi: 'दाल वेज',
    te: 'కూరగాయల పప్పు',
    kn: 'ತರಕಾರಿ ಬೇಳೆ ಸಾರು',
    ml: 'വെജിറ്റബിൾ പരിപ്പ് കറി',
    ar: 'عدس بالخضروات'
  },
  'Egg Bhurji': {
    en: 'Egg Bhurji',
    ta: 'முட்டை பொடிமாஸ்',
    hi: 'अंडा भुर्जी',
    te: 'గుడ్డు పొరటు',
    kn: 'ಮೊಟ್ಟೆ ಬುರ್ಜಿ',
    ml: 'മുട്ട ബുർജി',
    ar: 'شكشوكة بيض'
  },
  'Paneer/Tofu Pepper Fry': {
    en: 'Paneer/Tofu Pepper Fry',
    ta: 'பன்னீர் / டோஃபு பெப்பர் ஃப்ரை',
    hi: 'पनीर पेपर फ्राई',
    te: 'పన్నీర్ పెప్పర్ ఫ్రై',
    kn: 'ಪನೀರ್ ಪೆಪ್ಪರ್ ಫ್ರೈ',
    ml: 'പനീർ കുരുമുളക് ഫ്രൈ',
    ar: 'بانير بالفلفل'
  },
  'Vegetable Sambar': {
    en: 'Vegetable Sambar',
    ta: 'கதம்ப காய்கறி சாம்பார்',
    hi: 'वेज सांभर',
    te: 'కూరగాయల సాంబారు',
    kn: 'ತರಕಾರಿ ಸಾಂಬಾರು',
    ml: 'നാടൻ സാമ്പാർ',
    ar: 'إيدام السامبار'
  },
  'Pepper Chicken': {
    en: 'Pepper Chicken',
    ta: 'பெப்பர் சிக்கன்',
    hi: 'पेपर चिकन',
    te: 'మిరియాల కోడికూర',
    kn: 'ಪೆಪ್ಪರ್ ಚಿಕನ್',
    ml: 'കുരുമുളക് ചിക്കൻ',
    ar: 'دجاج بالفلفل الأسود'
  },
  'One-Pot Vegetable Khichdi': {
    en: 'One-Pot Vegetable Khichdi',
    ta: 'காய்கறி கிச்சடி',
    hi: 'वेज खिचड़ी',
    te: 'వెజిటబుల్ కిచిడీ',
    kn: 'ತರಕಾರಿ ಕಿಚಡಿ',
    ml: 'വെജിറ്റബിൾ ഖിച്ഡി',
    ar: 'خيتشدي بالخضار'
  }
};

/**
 * Return localized core dish title
 */
export function getCoreDishTitle(coreDish, lang = 'English') {
  const norm = coreDish ? coreDish.trim() : '';
  let item = CORE_DISH_NAMES[norm];
  if (!item) {
    const key = Object.keys(CORE_DISH_NAMES).find(k => k.toLowerCase() === norm.toLowerCase());
    if (key) item = CORE_DISH_NAMES[key];
  }
  if (!item) return norm;

  if (lang === 'Tamil') return item.ta || item.en;
  if (lang === 'Hindi') return item.hi || item.en;
  if (lang === 'Telugu') return item.te || item.en;
  if (lang === 'Kannada') return item.kn || item.en;
  if (lang === 'Malayalam') return item.ml || item.en;
  if (lang === 'Arabic') return item.ar || item.en;
  return item.en;
}

/**
 * Return localized state name
 */
export function getStateName(state, lang = 'English') {
  const item = STATE_LABELS[state];
  if (!item) return state;

  if (lang === 'Tamil') return item.ta || item.en;
  if (lang === 'Hindi') return item.hi || item.en;
  if (lang === 'Telugu') return item.te || item.en;
  if (lang === 'Kannada') return item.kn || item.en;
  if (lang === 'Malayalam') return item.ml || item.en;
  if (lang === 'Arabic') return item.ar || item.en;
  return item.en;
}

/**
 * Return localized style label, e.g. "தமிழ்நாடு ஸ்டைல்" or "Kerala Style"
 */
export function getStateStyleLabel(state, lang = 'English') {
  const sName = getStateName(state, lang);
  if (lang === 'Tamil') return `${sName} ஸ்டைல்`;
  if (lang === 'Hindi') return `${sName} शैली`;
  if (lang === 'Telugu') return `${sName} శైలి`;
  if (lang === 'Kannada') return `${sName} ಶೈಲಿ`;
  if (lang === 'Malayalam') return `${sName} ശൈലി`;
  if (lang === 'Arabic') return `طريقة ${sName}`;
  return `${sName} Style`;
}

/**
 * Return icon for state
 */
export function getStateIcon(state) {
  return STATE_ICONS[state] || '📍';
}

/**
 * Group raw recipes into unified base dishes with their state variants
 */
export function groupRecipesByDish(recipesList) {
  if (!recipesList || !Array.isArray(recipesList)) return [];

  const map = new Map();

  recipesList.forEach(r => {
    // core_dish is present in recipes.json, or extract base dish
    let core = r.core_dish;
    if (!core) {
      core = (r.meal || '')
        .replace(/^(Tamil Nadu|Kerala|Karnataka|Andhra Pradesh|Andhra|Telangana)\s+Style\s+/i, '')
        .trim();
    }
    if (!core) core = r.meal || 'Dish';

    if (!map.has(core)) {
      map.set(core, {
        coreDish: core,
        diet: r.diet,
        mealType: r.meal_type,
        variants: []
      });
    }

    map.get(core).variants.push(r);
  });

  return Array.from(map.values());
}

